import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_electronicDocuments: {
         dischargeSummary: {
            cannotIssueOnReopenedVisit: 'Nie można wystawić tego dokumentu w ponownie otwartej wizycie.',
            chooseMedicalDepartmentCode: 'Wybierz kod resortowy X',
            contactAdministratorForDepartmentCode:
               'Skontaktuj się z administratorem podmiotu, by uzupełnił go w danych podmiotu.',
            dischargeSummary: 'Informacja dla lekarza kierującego',
            dischargeSummaryDocumentCreateError: 'Nie udało się załadować formularza. Spróbuj ponownie.',
            documentGeneratingWithinMedicalField: 'Dokument generowany w ramach dziedziny',
            documentHasBeenPreparedAndWillBeSendAfterCompletingVisit:
               'Dokument został przygotowany i zostanie wysłany po zatwierdzeniu wizyty i wysłaniu Zdarzenia Medycznego',
            draftSaveFail: 'Nie udało się zapisać wersji roboczej. Spróbuj ponownie.',
            draftSaveSuccess: 'Wersja robocza została poprawnie zapisana.',
            fillDepartmentCodeIn: 'Uzupełnij go w <healthcareOrganizationSettingsLink />.',
            fillDiagnosticsScopeGuidelines: 'Uzupełnij wskazówki w zakresie diagnostyki...',
            fillOtherGuidelines: 'Uzupełnij inne wskazówki...',
            fillPharmacotherapyScopeGuidelines: 'Uzupełnij wskazówki w zakresie farmakoterapii...',
            fillProvidedMedicalServiceDescription: 'Uzupełnij opis udzielonego świadczenia...',
            furtherMedicalTreatmentGuidelines: {
               sectionHeader: 'Wytyczne dotyczące dalszego postępowania medycznego',
               values: {
                  REFERRAL_FOR_HOSPITALIZATION_ISSUED: 'wydano skierowanie na hospitalizację',
                  SPECIALIST_CARE_NEEDED: 'wymaga dalszego leczenia w poradni specjalistycznej',
                  SPECIALIST_CARE_NOT_NEEDED: 'nie wymaga dalszego leczenia w poradni specjalistycznej',
               },
            },
            goBackToVisit: 'Wróć do wizyty',
            healthcareOrganizationData: 'danych podmiotu',
            inDiagnosticsScope: 'W zakresie diagnostyki',
            inPharmacotheraptyScope:
               'W zakresie farmakoterapii (w tym środki spożywcze specjalnego przeznaczenia żywieniowego)',
            informationRequiredForEDM: 'Do wysyłki EDM potrzebne są poniższe informacje.',
            medicalField: 'Dziedzina miejsca udzielania świadczeń',
            medicalFieldSaved: 'Zapisano dziedzinę dla tego MUŚ w panelu Moja Praktyka.',
            missingConfigurationData: 'Brakuje potrzebnej konfiguracji',
            missingDepartmentCode: 'Brakuje potrzebnego kodu resortowego?',
            missingNFZDepartment:
               'Do wysłania Informacji dla lekarza kierującego wymagana jest informacja o oddziale NFZ pacjenta.',
            noDepartmentCodes: 'Brak podanych kodów resortowych X.',
            other: 'Inne (w tym wyroby medyczne oraz wizyty kontrolne)',
            preparingDocument: 'Przygotowywanie dokumentu Informacji dla lekarza kierującego',
            procedurePerformed: 'Wykonana procedura',
            providedMedicalServiceDescription: 'Opis udzielonego świadczenia',
            referringPhysicianGuidelines: 'Wskazówki dla lekarza kierującego',
            saveAndContinue: 'Zapisz i kontynuuj',
            searchByName: 'Wyszukaj po nazwie...',
            searchMedicalFieldByCodeOrName: 'Wyszukaj dziedzinę po kodzie lub nazwie...',
            sendAndPrint: 'Wyślij i drukuj',
            speciality: 'Specjalność',
            specialtiesFetchError: 'Wystąpił błąd podczas pobierania listy specialości. Spróbuj ponownie',
         },
      },
   },
};

export const electronicDocumentsTranslationKeys = createScopedTranslationKeys(
   translations.pl,
   'visit_electronicDocuments'
);
export const dischargeSummaryTranslationKeys = electronicDocumentsTranslationKeys.dischargeSummary;
